const percentOff = (price, percentage) =>
  Math.round((Math.round(price * 100) * (100 - percentage)) / 100) / 100;

const getPlanPrice = (price, adjustment) => {
  if (adjustment?.adjustmentPercentage != null)
    return percentOff(price, adjustment.adjustmentPercentage);
  if (adjustment?.adjustmentAmount) return price - parseFloat(adjustment.adjustmentAmount.amount);
  if (adjustment?.price) return parseFloat(adjustment.price.amount);
  return price;
};

export const parseSubscriptionDiscounts = nodes =>
  (nodes || [])
    .map(({ automaticDiscount: discount }) => discount)
    .filter(
      discount =>
        discount?.type === 'DiscountAutomaticBasic' &&
        !discount.minimumRequirement &&
        discount.customerGets?.appliesOnSubscription &&
        !discount.customerGets.appliesOnOneTimePurchase
    )
    .map(({ customerGets: { items, value } }) => ({
      percentage: value?.percentage ?? null,
      amount: value?.amount?.amount != null ? parseFloat(value.amount.amount) : null,
      allItems: items?.type === 'AllDiscountItems',
      productIds: items?.products?.nodes?.map(({ id }) => id) || [],
      collectionIds: items?.collections?.nodes?.map(({ id }) => id) || [],
    }))
    .filter(({ percentage, amount }) => percentage != null || amount != null);

const appliesToProduct = (discount, shopifyData) =>
  discount.allItems ||
  discount.productIds.includes(`gid://shopify/Product/${shopifyData?.productId}`) ||
  discount.collectionIds.some(id => shopifyData?.collectionIds?.includes(id));

export const getSubscriptionPrice = (price, plan, discounts, shopifyData) => {
  const planPrice = getPlanPrice(price, plan?.priceAdjustments);
  const discount = (discounts || []).find(item => appliesToProduct(item, shopifyData));
  if (!discount) return planPrice;
  if (discount.percentage != null) return percentOff(planPrice, discount.percentage * 100);
  return Math.max(planPrice - discount.amount, 0);
};
